(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 4883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Page; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./context/index.js + 8 modules
var context = __webpack_require__(1550);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/common/Page/style.js

var PageStyle = styled_components_browser_esm/* default.main.attrs */.ZP.main.attrs(function (props) {
  return {};
}).withConfig({
  componentId: "sc-19co6x6-0"
})(["padding-top:var(--pageMarginTop);padding-bottom:var(--pageMarginBottom);&.productIndividual{padding-top:unset;padding-bottom:unset;}"]);
/* harmony default export */ var style = (PageStyle);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/common/Page/index.js

var _excluded = ["winWidth", "meta"];
 //* HOCs

 //* Components

 //* Context

 //* Styles





var Page = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var winWidth = _ref.winWidth,
      meta = _ref.meta,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  //! Router
  var router = (0,next_router.useRouter)(); //! URL

  var url = (0,react.useMemo)(function () {
    return "https://ngslot.com" + (router.locale !== 'en' ? '/' + router.locale : '') + router.asPath;
  }, [router]); //! Description

  var description = (0,react.useMemo)(function () {
    return (meta === null || meta === void 0 ? void 0 : meta.description) || 'Ng slot meta description';
  }, [meta === null || meta === void 0 ? void 0 : meta.description]); //! Title

  var title = (0,react.useMemo)(function () {
    return (meta === null || meta === void 0 ? void 0 : meta.title) || 'Ng slot';
  }, [meta === null || meta === void 0 ? void 0 : meta.title]);
  (0,react.useEffect)(function () {
    window.history.scrollRestoration = 'manual';
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: title,
      description: description,
      canonical: url,
      type: "website",
      additionalMetaTags: [{
        name: 'keywords',
        content: meta === null || meta === void 0 ? void 0 : meta.keywords
      }],
      openGraph: {
        url: url,
        title: title,
        description: description,
        images: [{
          url: (meta === null || meta === void 0 ? void 0 : meta.image) || "https://ngslot.com" + '/images/logo.svg',
          alt: title
        }]
      },
      twitter: {
        handle: '@handle',
        site: '@site',
        cardType: 'summary_large_image'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(style, {
      style: props.style,
      className: props.className,
      children: props.children
    })]
  });
});
/* harmony default export */ var common_Page = ((0,context/* withUIContext */.pP)(Page, ['winWidth']));

/***/ }),

/***/ 4685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_NewsItem; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/pages/NewsItem/style.js

var NewsItemStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-ra2l0y-0"
})(["--dateMarginBottom:var(--sp5x);--titleMaxWidth:var(--sp169x);--descriptionMaxWidth:var(--sp119x);--itemMarginTop:var(--sp7x);overflow:hidden;margin-top:var(--itemMarginTop);.short-info{margin-bottom:var(--itemMarginTop);}.date{margin-bottom:var(--dateMarginBottom);}.newsItemTitle{max-width:var(--titleMaxWidth);background-image:linear-gradient(to right,var(--cream),var(--cream) 50%,var(--orange) 50%);background-size:200%;background-position:0%;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;transition:background-position var(--trTime2);}@media (hover:hover){&:hover{.newsItemTitle{background-position:-100%;}.animLine{transform:translateX(0%);}}}.newsItemDescription{max-width:var(--descriptionMaxWidth);}@media only screen and (max-width:", ") and (min-width:", "){--dateMarginBottom:var(--sp4x);--titleMaxWidth:var(--sp125x);--descriptionMaxWidth:var(--sp88x);--itemMarginTop:var(--sp6x);}@media only screen and (max-width:", ") and (min-width:", "){--dateMarginBottom:var(--sp3x);--titleMaxWidth:var(--sp96x);--descriptionMaxWidth:var(--sp65x);--itemMarginTop:var(--sp5x);}@media only screen and (max-width:", ") and (min-width:", "){--dateMarginBottom:var(--sp2x);--titleMaxWidth:var(--sp61x);--descriptionMaxWidth:var(--sp45x);--itemMarginTop:var(--sp4x);}@media only screen and (max-width:", ") and (min-width:", "){--dateMarginBottom:var(--sp2x);--titleMaxWidth:100%;--descriptionMaxWidth:100%;--itemMarginTop:var(--sp4x);.short-info{flex-direction:column;.newsItemDescription{margin-top:var(--sp3x);}}}@media only screen and (max-width:", "){--dateMarginBottom:var(--sp2x);--titleMaxWidth:100%;--descriptionMaxWidth:100%;--itemMarginTop:var(--sp3x);.short-info{flex-direction:column;.newsItemDescription{margin-top:var(--sp2x);}}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeLMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeM;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSize;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var style = (NewsItemStyle);
// EXTERNAL MODULE: ./components/common/Text/index.js
var Text = __webpack_require__(6078);
// EXTERNAL MODULE: ./components/common/CustomLink/index.js
var CustomLink = __webpack_require__(2544);
// EXTERNAL MODULE: ./components/common/AnimationWrap/index.js
var AnimationWrap = __webpack_require__(7125);
// EXTERNAL MODULE: ./components/common/Line/index.js + 1 modules
var Line = __webpack_require__(5596);
// EXTERNAL MODULE: ./context/index.js + 8 modules
var context = __webpack_require__(1550);
// EXTERNAL MODULE: ./helpers/_gsapFunctions.js
var _gsapFunctions = __webpack_require__(6282);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/pages/NewsItem/index.js
 //* Style

 //* Components




 //* HOC's

 //* Helpers





var NewsItem = function NewsItem(_ref) {
  var itemData = _ref.itemData,
      winWidth = _ref.winWidth;

  //! States
  var _useState = (0,react.useState)(),
      secObj = _useState[0],
      setSecObj = _useState[1]; //! Refs


  var items = (0,react.useRef)([]);
  var dateRef = (0,react.useRef)();
  var titleRef = (0,react.useRef)();
  var descriptionRef = (0,react.useRef)();
  var lineRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    if (items !== null && items !== void 0 && items.current) {
      setSecObj([items.current]);
    }
  }, [items]);
  var startAnimeArr = (0,react.useCallback)(function (x) {
    if (x) {
      //! changeWidth(item, stagger, delay)
      (0,_gsapFunctions/* slideDown */.qw)([dateRef.current, titleRef.current, descriptionRef.current], 0.2); //! changeWidth(item)

      (0,_gsapFunctions/* changeWidth */.wh)(lineRef.current);
    }
  }, []);
  var storeDate = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflowHidden animWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        className: 'h9 maisonMedium date translate-200',
        text: itemData.date.replace(',', ', '),
        ref: dateRef
      })
    });
  }, [itemData]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(style, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimationWrap/* default */.Z, {
      state: secObj,
      startAnimeArr: startAnimeArr,
      dependency: winWidth,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CustomLink/* default */.Z, {
        url: '/news/' + itemData.slug,
        ref: items,
        children: [storeDate, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "FlexBox spaceBetween short-info",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "overflowHidden animWrap",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              className: 'h5 maisonSemiBold newsItemTitle translate-200',
              text: itemData.title,
              ref: titleRef
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "overflowHidden animWrap",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              className: 'h9 maisonMedium newsItemDescription translate-200',
              text: itemData.short_description,
              ref: descriptionRef
            })
          })]
        }), winWidth < 1024 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: lineRef,
          className: "animStartStateWidth",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Line/* default */.Z, {
            color: "orange"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: lineRef,
          className: "animStartStateWidth",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Line/* default */.Z, {})
        })]
      })
    })
  });
};

/* harmony default export */ var pages_NewsItem = ((0,context/* withUIContext */.pP)(NewsItem, ['winWidth']));

/***/ }),

/***/ 3475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_news; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/common/Page/index.js + 1 modules
var Page = __webpack_require__(4883);
// EXTERNAL MODULE: ./components/common/Container/index.js + 1 modules
var Container = __webpack_require__(3749);
// EXTERNAL MODULE: ./components/common/Text/index.js
var Text = __webpack_require__(6078);
// EXTERNAL MODULE: ./components/common/FancyButton/index.js + 3 modules
var FancyButton = __webpack_require__(8642);
// EXTERNAL MODULE: ./components/common/AnimationWrap/index.js
var AnimationWrap = __webpack_require__(7125);
// EXTERNAL MODULE: ./components/pages/NewsItem/index.js + 1 modules
var NewsItem = __webpack_require__(4685);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./styles/pages/news.js

var NewsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-x5k1tw-0"
})(["--titleMarginBottom:var(--sp13x);.title{margin-bottom:var(--titleMarginBottom);}@media only screen and (max-width:", ") and (min-width:", "){--titleMarginBottom:var(--sp10x);}@media only screen and (max-width:", ") and (min-width:", "){--titleMarginBottom:var(--sp8x);}@media only screen and (max-width:", ") and (min-width:", "){--titleMarginBottom:var(--sp7x);}@media only screen and (max-width:", ") and (min-width:", "){--titleMarginBottom:var(--sp7x);}@media only screen and (max-width:", "){--titleMarginBottom:var(--sp5x);}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeLMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeM;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSize;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var news = (NewsStyle);
// EXTERNAL MODULE: ./context/index.js + 8 modules
var context = __webpack_require__(1550);
// EXTERNAL MODULE: ./helpers/index.js + 5 modules
var helpers = __webpack_require__(9943);
// EXTERNAL MODULE: ./helpers/_gsapFunctions.js
var _gsapFunctions = __webpack_require__(6282);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./pages/news/index.js

 //* Components






 //* Style

 //* HOC's

 //* Api

 //* Helpers





var News = function News(_ref) {
  var pages = _ref.pages,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang,
      winWidth = _ref.winWidth;
  var pageData = (0,react.useMemo)(function () {
    var _pages$pageParams$nam;

    return pages === null || pages === void 0 ? void 0 : (_pages$pageParams$nam = pages[pageParams.name]) === null || _pages$pageParams$nam === void 0 ? void 0 : _pages$pageParams$nam[selectedLang];
  }, [pages, pageParams, selectedLang]); //! Refs

  var items = (0,react.useRef)([]);
  var titleRef = (0,react.useRef)(); //! States

  var _useState = (0,react.useState)(null),
      newsItems = _useState[0],
      setNewsItems = _useState[1];

  var _useState2 = (0,react.useState)(null),
      hasMore = _useState2[0],
      setHasMore = _useState2[1];

  var _useState3 = (0,react.useState)(),
      secObj = _useState3[0],
      setSecObj = _useState3[1];

  var storeNews = (0,react.useMemo)(function () {
    return newsItems === null || newsItems === void 0 ? void 0 : newsItems.map(function (element, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsItem/* default */.Z, {
        itemData: element
      }, index);
    });
  }, [newsItems]);

  var loadMore = function loadMore() {
    return helpers/* api.get */.hi.get('posts', 'en', {
      offset: newsItems.length
    }).then(function (res) {
      setNewsItems([].concat((0,toConsumableArray/* default */.Z)(newsItems), (0,toConsumableArray/* default */.Z)(res.posts)));
      setHasMore(res.hasMore);
    });
  };

  (0,react.useEffect)(function () {
    setNewsItems(pageData === null || pageData === void 0 ? void 0 : pageData.posts);
    setHasMore(pageData === null || pageData === void 0 ? void 0 : pageData.hasMore);
  }, [pageData]);
  (0,react.useEffect)(function () {
    if (items !== null && items !== void 0 && items.current) {
      setSecObj([items.current]);
    }
  }, [items, winWidth]);
  var startAnimeArr = (0,react.useCallback)(function (x) {
    if (x) {
      //! slideDown(item, stagger, delay)
      (0,_gsapFunctions/* slideDown */.qw)([titleRef.current]);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(news, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimationWrap/* default */.Z, {
      state: secObj,
      startAnimeArr: startAnimeArr,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Page/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
          ref: items,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "overflowHidden title",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              tag: 'h3',
              className: "terminaBold translate-100",
              text: "news",
              ref: titleRef
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: storeNews
          }), hasMore && /*#__PURE__*/(0,jsx_runtime.jsx)(FancyButton/* default */.Z, {
            onClick: loadMore,
            type: "long",
            content: "loadMore"
          })]
        })
      })
    })
  });
};

/* harmony default export */ var pages_news = ((0,context/* withUIContext */.pP)((0,context/* withDataContext */.hX)(News, ['pages']), ['winWidth']));

/***/ }),

/***/ 2616:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(3475);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,642,774,888,179], function() { return __webpack_exec__(2616); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);